var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsana = function SvgAsana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 155 144"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF584A",
    d: "M110.73 34.014c0 18.53-15.025 33.567-33.556 33.567-18.542 0-33.567-15.025-33.567-33.567S58.632.447 77.174.447c18.53 0 33.556 15.025 33.556 33.567M33.567 75.967C15.037 75.967 0 90.992 0 109.523s15.025 33.567 33.567 33.567 33.567-15.025 33.567-33.567c0-18.531-15.025-33.556-33.567-33.556m87.203 0c-18.543 0-33.568 15.025-33.568 33.567s15.025 33.567 33.568 33.567c18.53 0 33.567-15.025 33.567-33.567s-15.025-33.567-33.567-33.567"
  })));
};
export default SvgAsana;